import React from "react";
import { Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";
import { DefaultLanding, RequireAuth } from "./auth";

import Login from "./pages/Login";
import AgencyPortfolio from "./pages/AgencyPortfolio";
import AgencyClientDetail from "./pages/AgencyClientDetail";
import AgencyAlerts from "./pages/AgencyAlerts";
import AgencyRecommendations from "./pages/AgencyRecommendations";
import AgencyOnboarding from "./pages/AgencyOnboarding";
import AgencyGeoLeaderboard from "./pages/AgencyGeoLeaderboard";
import AgencyErrors from "./pages/AgencyErrors";
import ClientMarketing from "./pages/ClientMarketing";
import ClientPastReports from "./pages/ClientPastReports";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* Authenticated shell */}
      <Route element={<RequireAuth><Layout /></RequireAuth>}>
        {/* Agency admin */}
        <Route path="/portfolio" element={<RequireAuth role="agency_admin"><AgencyPortfolio /></RequireAuth>} />
        <Route path="/clients/:clientId" element={<RequireAuth role="agency_admin"><AgencyClientDetail /></RequireAuth>} />
        <Route path="/alerts" element={<RequireAuth role="agency_admin"><AgencyAlerts /></RequireAuth>} />
        <Route path="/recommendations" element={<RequireAuth role="agency_admin"><AgencyRecommendations /></RequireAuth>} />
        <Route path="/geo-leaderboard" element={<RequireAuth role="agency_admin"><AgencyGeoLeaderboard /></RequireAuth>} />
        <Route path="/errors" element={<RequireAuth role="agency_admin"><AgencyErrors /></RequireAuth>} />
        <Route path="/onboard" element={<RequireAuth role="agency_admin"><AgencyOnboarding /></RequireAuth>} />

        {/* Client user */}
        <Route path="/my/:clientId" element={<RequireAuth role="client_user"><ClientMarketing /></RequireAuth>} />
        <Route path="/my/:clientId/history" element={<RequireAuth role="client_user"><ClientPastReports /></RequireAuth>} />
      </Route>

      <Route path="*" element={<DefaultLanding />} />
    </Routes>
  );
}
